// eslint-disable-next-line max-len
export const slideMouseDownHandler = (stateController, focusSlide, nextSlides, previousSlides) => (downEvent) => {
  let didMove = false;
  const originX = downEvent.clientX;
  const trgt = downEvent.currentTarget;

  const onMouseMove = () => {
    // Sets a state that gets checked for in onMouseUp to determine
    // whether this is a swipe/drag or click
    if (didMove === false) {
      didMove = true;
    }
  };

  const onMouseUp = (innerEvent) => {
    trgt.removeEventListener('mousemove', onMouseMove);
    trgt.removeEventListener('mouseup', onMouseUp);

    // If this is a swipe/drag, don't do anything. Rely on event handling
    // through Nuka Carousel / afterSlide callback.
    if (didMove === true) {
      const innerX = innerEvent.clientX;
      if (innerX < originX && nextSlides) {
        nextSlides();
        return;
      } if (innerX > originX && previousSlides) {
        previousSlides();
        return;
      }
      if (innerX !== originX) {
        return;
      }
    }

    let slideRootNode = innerEvent.target;
    if (!slideRootNode.getAttribute('data-index')) {
      while (slideRootNode.getAttribute('data-index') === null) {
        slideRootNode = slideRootNode.parentNode;
      }
    }

    const nextSlideIndex = parseInt(slideRootNode.getAttribute('data-index'), 10);

    if (slideRootNode.getAttribute('data-affiliate-link')) {
      window.open(slideRootNode.getAttribute('data-affiliate-link'));
      return;
    }

    if (slideRootNode.getAttribute('data-content-link')) {
      window.location.href = slideRootNode.getAttribute('data-content-link');
      return;
    }

    focusSlide(nextSlideIndex);
  };

  trgt.addEventListener('mousemove', onMouseMove);
  trgt.addEventListener('mouseup', onMouseUp);
};
